import { render, staticRenderFns } from "./readmail.vue?vue&type=template&id=7cc3bb48"
import script from "./readmail.vue?vue&type=script&lang=js"
export * from "./readmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports